export default __webpack_public_path__ + "static/media/nostalgiaspace.3683a39b.png";